import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';

import { Box, CircularProgress, Snackbar, Alert, Button } from '@mui/material';
import { Add } from '@mui/icons-material';

import useErrorManager from "../../hooks/useErrorManager";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import PageContainer from '../Layout/PageContainer';
import GenericTable from '../Layout/Table/GenericTable';
import TextLinkButton from "../Layout/TextLinkButton"
import TextFilter from "../Layout/Table/TextFilter"

import { fwdDataTypes } from '../../constants/fwdDataTypes';

import { useNotification } from '../../contexts/NotificationContext';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext'; // Import breadcrumb context


function FwdProfiles() {
    const [fwdProfiles, setFwdProfiles] = useState([]);
    const [filterText, setFilterText] = useState("");

    const [loading, setLoading] = useState(true);
    
    const { setError, clearError, getError } = useErrorManager();
    const { showNotification } = useNotification();
    const { updateBreadcrumb } = useBreadcrumb(); // Use breadcrumb context to update breadcrumb

    const location = useLocation();
    const navigate = useNavigate();
    const axiosInstance = useAxiosPrivate();

    const columns = [
        { id: 'name', label: 'Name', filtered: true, render: (item) => <TextLinkButton action={() =>navigate(`/profiles/${item.id}`)} text={item.name}/> },
        { id: 'dataType', label: 'Action type',  render: (item) => fwdDataTypes[item.dataType] || item.dataType },
        { id: 'profileType', label: 'Profile type' },
        { id: 'destinationCount', label: 'Number of destinations' },
        { id: 'assignmentCount', label: 'Number of forwarding assignments' }
    ];

    useEffect(() => {
        const fetchFwdProfiles = async () => {
            try {
                const response = await axiosInstance.get('/fwd/profiles/list', {
                    withCredentials: true,
                });
                setFwdProfiles(response.data);
                clearError('fetch');
                setLoading(false);

            } catch (error) {
                setError('fetch',error.message);
                showNotification('Failed to fetch Forwarding Profiles','error')
                setLoading(false);
            }
        };

        updateBreadcrumb([
            { label: 'Manage Forwarding Profiles'}
        ]);

        fetchFwdProfiles();
    }, []);

    useEffect(() => {
        if (location.state?.success) {
            showNotification(location.state.success,'success');
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state]);
    

    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
    };


    return (
            <PageContainer>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="10px">
                            <TextFilter
                                columns={columns}
                                onFilterChange={handleFilterChange}
                            />
                            <Button onClick={() => navigate(`/profiles/create`)} variant="contained" color="primary">
                                <Add/>
                            </Button>
                        </Box>

                        <GenericTable
                            items={fwdProfiles}
                            columns={columns}
                            filterText={filterText}
                        />
                    </>
                )}
            </PageContainer>
    );
}

export default FwdProfiles;